<style scoped lang="scss">
@import "@/assets/scss/global.scss";

.title-bar {
  max-width: 1032px;
  margin-left: auto;
  margin-right: auto;

  font-size: 24pt;
  font-weight: 300;
  line-height: 47px;
  z-index: 2;
  letter-spacing: 0.96px;
  min-width: 323px;
  color: $glaze-blue;

  @media (max-width: 323px) {
    min-width: 296px;
    font-size: 36px;
  }
}

.header-background {
  background-color: #fafafa;
  padding-top: 42px;
  padding-bottom: 42px;
}

.search-bar-container {
  width: 400px;
  max-width: 400px;
}

.search-bar {
  width: 400px;
}

.collection-selector-wrapper {
  border-top: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
  height: 46px;
}

.glaze-content-wrapper {
  max-width: 1032px;
  margin-left: auto;
  margin-right: auto;
}

.selector-chevron {
  transform: rotate(90deg);
}

.gallery-wrapper {
  margin-top: 50px;
  margin-bottom: 100px;
  height: 100%;
}

.browse-wrapper {
  height: 100%
}

.image-wrapper {
  width: 232px;
  max-width: 232px;
  height: 232px;
  margin: 8px 8px 16px 8px;
}

.position-search-bar {
  justify-content: center;
}

.selector-button {
  width: 220px;
  justify-content: space-between;
      font-weight: 400;
    text-transform: capitalize;
}

.selector-text {
  width: 180px;
      font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
      white-space: nowrap;
}

.selector-chevron {
  width: 20px;
  margin-bottom: 6px;
}

.glaze-menu-item-text {
    font-size: 12px;
    text-align: left;
    min-width: 220px;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.glaze-menu-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    z-index: 10;
}

.glaze-menu-container {
    background-color: #fff;
    height: 400px;
    overflow-y: scroll;
    min-width: 220px;
    top: 247px;
    left: 765px;
    transform-origin: left top;
    z-index: 8;
}

.glaze-h1 {
    font-size: 24px;
    font-weight: 300;
    z-index: 2;
    letter-spacing: .96px;
    min-width: 323px;
    color: #022266;
    line-height: 48px;
    font-size: 32px;
}
</style>

<template>
  <div class="browse-wrapper">
    <div class="header-background">
      <v-layout class="title-bar" row>
        <v-flex class="glaze-h1">
          Browse Illustrations
        </v-flex>
        <v-layout class="position-search-bar">
          <v-flex no-grow class="search-bar-container">
            <v-flex class="search-bar">
              <v-flex no-grow>
                <v-text-field no-grow class="search-bar" label="Solo" placeholder="Search" solo v-model="searchQuery"
                  @input="search(searchQuery)"></v-text-field>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-layout>
    </div>
    <div class="collection-selector-wrapper">
      <div class="glaze-content-wrapper">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small flat class="selector-button hidden-sm-and-down" v-on="on">
              <div class="selector-text">Collection: {{ selectedText }}</div>
              <div class="selector-chevron"> <img src="@/assets/icons/chevron_right.svg" alt=""></div>
            </v-btn>
          </template>
          <v-list class="glaze-menu-container">
            <v-list-tile class="glaze-menu-item" v-for="(key, index) in Object.keys(collections)" :key="index" @click="selectCollection(key)">
              <v-list-tile-title class="glaze-menu-item-text">{{ key }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="gallery-wrapper">
      <v-layout class="glaze-content-wrapper" column>
        <v-flex>
          <v-layout class="images-container" row wrap>
            <v-flex class="image-wrapper" v-for="(image, index) in searchResults" :key="index"
              @click="selectImage(image)">
              <progressive-image :src="imageUrl(image.ref)" :placeholder="imagePlaceholderUrl(image.ref)"
                :max-height="232"></progressive-image>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>


</template>

<script>
import Lunr from 'lunr';
import indexData from './index.json'
import ProgressiveImage from "@/components/images/ProgressiveImage";

// import { mapGetters } from "vuex";

export default {
  mounted: function () {
    this.searchIndex = Lunr.Index.load(indexData);
    const queryParam = this.$route.query.q;
    if (queryParam && queryParam.trim() !== '') {
      this.searchQuery = queryParam;
    }
    else {
      this.search("");
    }
  },
  data() {
    return {
      searchIndex: null, // For storing the Lunr index
      searchResults: [],
      collections: {
        "Browse All": "All",
        "Backgrounds": "backgrounds",
        "Places": "Places",
        "Travel": "Travel",
        "People": "People",
        "Teamwork": "Teamwork",
        "Animals": "Animals",
        "Empty State": "Empty State",
        "Mindfulness": "Mindfulness",
        "Around The House": "Around The House",
        "Business & Commerce": "Business & Commerce",
        "Health & Life Sciences": "Health & Life Sciences",
        "Technology": "Technology"
      },
      selectedCollection: "Browse All",
      searchQuery: "",
    };
  },
  methods: {
    imageUrl: function (imageId) {
      return `${process.env.VUE_APP_IMAGES_ROOT}${imageId}/thumbs/464.png`;
    },
    imagePlaceholderUrl: function (imageId) {
      return `${process.env.VUE_APP_IMAGES_ROOT}${imageId}/thumbs/232c.png`;
    },
    initCollections: function () {
      for (var e = this.$store.state.collectionList, t = 0; t < e.length; t++)
        "" != e[t].title && this.$set(this.collections, e[t].title, !1)
    },
    selectCollection(selection) {
      this.selectedCollection = selection;
      if (selection == "Browse All") {
        this.searchQuery = "";
      }
      else {
        this.searchQuery = `collection:${selection}`;
        if (this.$route.query.q !== this.searchQuery) {
          this.$router.replace({ query: { ...this.$route.query, q: this.searchQuery } });
        }
      }
    },
    selectImage(image) {
      this.$router.push(`/image/${image.ref}`);
    },
    // browseAll: function () {
    //   this.selectedCollection = "",
    //     this.deselectAll(),
    //     this.$store.dispatch("search", {
    //       searchAll: !0,
    //       hide: !1,
    //       query: ""
    //     })
    // },
    // toggle: function (e) {
    //   this.selectedCollection != e && (this.collections[this.selectedCollection] = !1),
    //     this.selectedCollection = e,
    //     this.collections[e] = !0,
    //     this.runSearch()
    // },
    // runSearch: function () {
    //   var e = "";
    //   this.selectedCollection && (e = "collection:".concat(this.selectedCollection)),
    //     this.$store.dispatch("searchRaw", {
    //       query: e,
    //       hide: !1
    //     })
    // },
    search(query) {
      if (!this.searchIndex) {
        console.error("Search index not available.");
        return;
      }
      const queryParam = this.$route.query.q;
      if (queryParam && queryParam.trim() !== '' && queryParam.includes('collection:') && queryParam.split(':')[1] != this.selectedCollection) {
        this.selectedCollection = queryParam.split(':')[1];
        this.searchQuery = queryParam;
        this.$router.replace({ query: {} });
      }

      let newQuery = ""
      if (query != "") {
        newQuery = `${query}^100 ${query}*^10 ${query}~1`;
      }
      this.searchResults = this.searchIndex.search(newQuery);
      // console.log(this.searchResults);
    }
  },
  watch: {
    // eslint-disable-next-line
    $route(to, from) {
      window.scrollTo(0, 0);

      const queryParam = this.$route.query.q;
      if (queryParam && queryParam.trim() !== '') {
        this.selectedCollection = queryParam.includes('collection:') ? queryParam.split(':')[1] : '';
        this.searchQuery = queryParam;
      }
    },
    searchQuery: function (to, from) {
      if (to != from) {
        this.search(to);
      }

    },
    // collectionList: function (e, t) {
    //   this.initCollections()
    // }
  },
  computed: {
    selectedText: function () {
      if (this.searchQuery != "") {
        if (this.selectedCollection && this.searchQuery == `collection:${this.selectedCollection}`) {
          return this.selectedCollection;
        }
        return "Unselected";
      }
      if (this.searchQuery == "") {
        if (this.selectedCollection) {
          return this.selectedCollection;
        }
        return "All";
      }
    },
  },
  created() { },
  components: {
    ProgressiveImage,
  }
};
</script>
